import { render, staticRenderFns } from "./crud_levels.vue?vue&type=template&id=0cc096a2&scoped=true"
import script from "./crud_levels.vue?vue&type=script&lang=js"
export * from "./crud_levels.vue?vue&type=script&lang=js"
import style0 from "./crud_levels.vue?vue&type=style&index=0&id=0cc096a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc096a2",
  null
  
)

export default component.exports